import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LOYALTY_CONFIG } from '../config.token';
import { DeviceContextService } from '../services/device-context.service';

export const loyaltyHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const cfg = inject(LOYALTY_CONFIG);
  const dev = inject(DeviceContextService);

  if (!req.url.startsWith(cfg.baseUrl)) return next(req);

  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': dev.acceptLanguage,
        'x-device-id': dev.deviceId(),
        'x-platform': 'web',
      },
    }),
  );
};
